var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwitchIconGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3484px",
    height: "1760px",
    viewBox: "0 0 3484 1760",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "switch-icon-grey",
    transform: "translate(1742.000000, 880.000000) scale(-1, 1) translate(-1742.000000, -880.000000) ",
    fill: "#4B4B4A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1287.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 460.299782,
    width: 2071,
    height: 240
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(1820.766590, 785.999996) rotate(45.000000) translate(-1820.766590, -785.999996) ",
    x: 1700.76659,
    y: 375.999996,
    width: 240,
    height: 820
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(1821.766590, 375.000004) rotate(-45.000000) translate(-1821.766590, -375.000004) ",
    x: 1701.76659,
    y: -34.9999964,
    width: 240,
    height: 820
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1098.500000, 1179.500000) scale(-1, 1) translate(-1098.500000, -1179.500000) translate(0.000000, 599.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 460.299782,
    width: 2071,
    height: 240
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(1820.766590, 785.999996) rotate(45.000000) translate(-1820.766590, -785.999996) ",
    x: 1700.76659,
    y: 375.999996,
    width: 240,
    height: 820
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(1821.766590, 375.000004) rotate(-45.000000) translate(-1821.766590, -375.000004) ",
    x: 1701.76659,
    y: -34.9999964,
    width: 240,
    height: 820
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchIconGrey);
export default __webpack_public_path__ + "static/media/switch-icon-grey.4883595e70251521f2d07feeb5f106f1.svg";
export { ForwardRef as ReactComponent };